export default __webpack_public_path__ + "static/media/businessteam.93a5db50.jpg";